import React from "react";
import { LuCircleCheck } from "react-icons/lu";
import { MATCH_CRITERIA } from "./content";

export default function MatchCriteria() {
  return (
    <ul className="tw-mt-8 tw-mb-0 tw-grid tw-grid-cols-2 tw-list-none tw-gap-3 tw-p-0 xs:tw-grid-cols-1">
      {MATCH_CRITERIA.map((criterion) => (
        <li
          key={criterion}
          className="tw-flex tw-items-center tw-gap-2.5 tw-rounded-full tw-bg-[#eef5fb] tw-px-4 tw-py-3 tw-text-sm tw-font-bold tw-leading-5 tw-text-[#193955]"
        >
          <LuCircleCheck aria-hidden className="tw-h-[18px] tw-w-[18px] tw-shrink-0 tw-text-[#087bd3]" />
          {criterion}
        </li>
      ))}
    </ul>
  );
}
